const trustItems = [
  { icon: 'ri-star-fill', value: '5.0 Stars', sub: '50+ Google Reviews', gold: true, badge: 'Google Verified' },
  { icon: 'ri-shield-star-line', value: 'Top Rated', sub: 'Washington & Brazos County', badge: 'Local Leader' },
  { icon: 'ri-award-line', value: 'Avvo / Justia', sub: 'Top Criminal Defense', badge: 'Nationally Listed' },
  { icon: 'ri-lock-2-line', value: 'Confidential', sub: 'Attorney-Client Privilege', badge: 'Always Protected' },
  { icon: 'ri-time-fill', value: 'Same-Day', sub: 'Response Available', badge: 'Fast Response' },
];

export default function SectionTrustBar() {
  return (
    <section className="relative bg-[#050a12] border-b border-white/6">
      {/* Top gold micro-line */}
      <div className="h-[1px] bg-gradient-to-r from-transparent via-[#c9a84c]/30 to-transparent" />
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-5">
          {trustItems.map((item, idx) => (
            <div
              key={item.value}
              className={`relative flex items-center gap-4 px-7 py-6 group hover:bg-white/3 transition-all duration-300 cursor-default ${
                idx < trustItems.length - 1 ? 'border-r border-white/6' : ''
              }`}
            >
              {/* Hover gold bar */}
              <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-[#c9a84c] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              <div className="w-11 h-11 flex items-center justify-center flex-shrink-0 bg-[#c9a84c]/10 border border-[#c9a84c]/20 rounded-xl group-hover:bg-[#c9a84c]/20 transition-all duration-300">
                <i className={`${item.icon} text-[#c9a84c] text-lg`} />
              </div>
              <div className="min-w-0">
                <p className="text-white font-bold text-sm leading-tight truncate">{item.value}</p>
                <p className="text-white/40 text-xs mt-0.5 truncate">{item.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="h-[1px] bg-gradient-to-r from-transparent via-white/5 to-transparent" />
    </section>
  );
}
